// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Uso4","log":"ModalInventoryLogs_log__2F_tY","date":"ModalInventoryLogs_date__J6ssp","userName":"ModalInventoryLogs_userName__2ktHZ"};